export default __webpack_public_path__ + "static/media/Mobilization-position-on.0ae4583a.svg";